module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp123_5010.e1ab2566.png";